import { useMutation, useQueryClient } from "react-query";
import { updateTags } from "../api/updateTags";
import { ITags } from "../components/interfaces/ITags";

export const useTagUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (updatedTags: ITags) =>
      updateTags(updatedTags),
    {
      onError: (error) => {
        console.error(error);
      },
      onSettled: () => {
        queryClient.invalidateQueries("tags");
      },
    }
  );
};
